// extracted by mini-css-extract-plugin
export default {"search":"IukFSjPl6R","listContainer":"dtk6mHK0Kb","list":"eHAoonQO1f"};